/** Configures recordings so a page refresh cannot reuse another account's replay identity. */
import { replayIntegration } from "@sentry/vue"

export function createPrivacyReplayIntegration(): ReturnType<typeof replayIntegration> {
	return replayIntegration({
		maskAllText: true,
		maskAllInputs: true,
		blockAllMedia: true,
		// Keep identity in memory even if stopping the previous recording is slow.
		stickySession: false,
	})
}
